import Vue from 'vue'
import Vuex from 'vuex'
import createPersistedState from "vuex-persistedstate";
import * as api from '@/api'

Vue.use(Vuex)

const state = {
    IsLogin : false,
    IsLeftMenuCollapse: false,
    IsOrgLogin : false,
    UserRole : 'User'
}
const mutations = {
    setLogin(state, val) { Vue.set(state, 'IsLogin', val) },
    setLeftMenuCollapse(state, val) { Vue.set(state, 'IsLeftMenuCollapse', val) },
    setOrgAdmin(state, val) { Vue.set(state, 'IsOrgLogin', val) },
    setUserRole(state, val) { Vue.set(state, 'UserRole', val) }
}
const getters = {
    IsLogin: state => state.IsLogin,  
    IsOrgLogin: state => state.IsOrgLogin,  
}
const actions = {
    getLogin({ commit, isLogin }) {
      commit('setLogin', isLogin)
    },
    getLeftMenuCollapse({ commit }, isCollapse){
      commit('setLeftMenuCollapse', isCollapse)
    },
    getOrgAdmin({ commit },isOrgAdmin) {
      console.log('isOrgAdmin ' + isOrgAdmin)
      commit('setOrgAdmin', isOrgAdmin)
    },
    getUserRole({ commit },role) {
      console.log('setUserRole ' + role)
      commit('setUserRole', role)
    }
    /*
    updateValues({ commit, dispatch, state }, editorValues) {
        const current = state.currentSection;
        const jsonStringValues = JSON.stringify(editorValues, null, 2);
    
        return new Promise((resolve, reject) => {
          api
            .updateValues(current, jsonStringValues)
            .then(response => {
              commit("valuesUpdated", true);
              commit("updateEditorValues", editorValues);
              resolve(response);
            })
            .catch(error => {
              console.error("Could not Update " + current + " Values", error);
              commit("valuesUpdated", false);
              reject(error);
            });
        });
      },
      */
}

export default new Vuex.Store({
    state,
    getters,
    mutations,
    actions,
    plugins: [createPersistedState()],
  })


// WEBPACK FOOTER //
// ./src/store/index.js